var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "container-item-wrapper",
    {
      style: {
        marginTop: _vm.widget.options.topMargin + 20 + "px !important" || "",
        marginBottom: _vm.widget.options.bottomMargin + "px !important" || "",
      },
      attrs: { widget: _vm.widget },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.widget.options.hidden,
              expression: "!widget.options.hidden",
            },
          ],
          key: _vm.widget.id,
          staticClass: "tab-container",
        },
        [
          _c(
            "el-tabs",
            {
              ref: _vm.widget.id,
              class: [_vm.customClass],
              attrs: { type: _vm.widget.displayType },
              model: {
                value: _vm.activeTabName,
                callback: function ($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName",
              },
            },
            _vm._l(_vm.visibleTabs, function (tab, index) {
              return _c(
                "el-tab-pane",
                {
                  key: index,
                  attrs: {
                    label: tab.options.label,
                    disabled: tab.options.disabled,
                    name: tab.options.name,
                  },
                },
                [
                  _vm._l(tab.widgetList, function (subWidget, swIdx) {
                    return [
                      "container" === subWidget.category
                        ? [
                            _c(_vm.getComponentByContainer(subWidget), {
                              key: swIdx,
                              tag: "component",
                              attrs: {
                                widget: subWidget,
                                "parent-list": tab.widgetList,
                                "index-of-parent-list": swIdx,
                                "parent-widget": _vm.widget,
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm._l(
                                    Object.keys(_vm.$scopedSlots),
                                    function (slot) {
                                      return {
                                        key: slot,
                                        fn: function (scope) {
                                          return [
                                            _vm._t(slot, null, null, scope),
                                          ]
                                        },
                                      }
                                    }
                                  ),
                                ],
                                null,
                                true
                              ),
                            }),
                          ]
                        : [
                            _c(subWidget.type + "-widget", {
                              key: swIdx,
                              tag: "component",
                              attrs: {
                                field: subWidget,
                                "parent-list": tab.widgetList,
                                "index-of-parent-list": swIdx,
                                "parent-widget": _vm.widget,
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm._l(
                                    Object.keys(_vm.$scopedSlots),
                                    function (slot) {
                                      return {
                                        key: slot,
                                        fn: function (scope) {
                                          return [
                                            _vm._t(slot, null, null, scope),
                                          ]
                                        },
                                      }
                                    }
                                  ),
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                    ]
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }